<template lang="pug">
  v-dialog(
    v-model="showDialog" 
    persistent max-width="500"
  )
    v-card
      v-card-title.primary.white--text
        p.mb-0 Update Details
        v-spacer
        v-btn(
          icon
          :disabled="updateLoading"
          @click.stop="$emit('cancel')"
          color="white"
        ).plain
          v-icon mdi-close
      v-card-text.pt-5
        v-form(
          v-model="validDetails"
          ref="form"
          lazy-validation
        )
          v-text-field(
            v-model="beneficiary.name.firstName"
            label="First Name"
            outlined
            autofocus
            :disabled="updateLoading"
            :rules="[v => !!v || 'First name is required']"
          )
          v-text-field(
            v-model="beneficiary.name.lastName"
            label="Last Name"
            outlined
            autofocus
            :disabled="updateLoading"
            :rules="[v => !!v || 'Last name is required']"
          )
          v-combobox(
            v-model="beneficiary.ambition"
            label="Ambition"
            hint="Select or type the scholar's ambition"
            filled
            outlined
            persistent-hint
            :items="professions"
            :filter="ambitionFilter"
            :rules="[v => !!v || 'Ambition is required']"
            :disabled="updateLoading"
          )
          v-textarea(
            v-model="beneficiary.storyShort"
            label="Story"
            outlined
            counter="168"
            no-resize
            :disabled="updateLoading"
            :rules="[v => !!v || 'Story is required', v => v.length <= 168 || 'Story should only be 168 characters or less']"
          )
          v-textarea(
            v-model="beneficiary.storyLong"
            label="Bio"
            outlined
            auto-grow
            :disabled="updateLoading"
            :rules="[v => !!v || 'Bio is required']"
          )
      v-divider
      v-card-actions
        v-spacer
        v-btn(
          @click.stop="updateDetails"
          large
          color="primary"
          depressed
          :disabled="updateLoading"
          :loading="updateLoading"
        ).plain Submit
        v-btn(
          @click.stop="$emit('cancel')"
          large
          depressed
          :disabled="updateLoading"
        ).plain Cancel
</template>

<script>
import { professions } from '../../utils/dropdown-list';
import _ from 'lodash';

export default {
  props: {
    beneficiary: {
      type: Object,
      default: () => ({
        name: {}
      })
    },
    showDialog: {
      type: Boolean
    }
  },
  data () {
    return {
      validDetails: false,
      updateLoading: false,
      professions,
      ambitionFilter: (item, queryText, itemText) => item.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    };
  },
  methods: {
    async updateDetails () {
      if (this.validDetails) {
        this.updateLoading = true;
        try {
          const opts = _.pick(
            this.beneficiary,
            ['id', 'name', 'ambition', 'storyShort', 'storyLong']
          );
          const updatedBeneficiary = await this.$store.dispatch('beneficiaries/update', opts);
          this.$enqueueSnack('Profile updated');
          this.$emit('submit', updatedBeneficiary);
        } catch (error) {
          this.$emit('cancel');
          this.$enqueueSnack(error);
        } finally {
          this.$refs.form.resetValidation();
          this.updateLoading = false;
        }
      }
    }
  }
};
</script>